import { DataGrid, GridCellParams } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { cafeTableHeader } from ".";
import { useCafeViewStore } from "../../store/cafeViewStore";
import { PostInfo } from "./types";

const styles = {
  wrapper: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
    "& .clickable": {
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  title: { fontWeight: "bold", fontSize: "min(5vw, 21px)" },
  describe: {
    fontWeight: "bold",
    color: "darkGrey",
    py: "1rem",
    fontSize: "min(4vw, 18px)",
  },
};

export const CafeTable = () => {
  const rows = useCafeViewStore(({ rows }) => rows);

  const onCellClick = ({
    field,
    row: { postId },
  }: GridCellParams<PostInfo>) => {
    if (field === "title") {
      window.open(
        `https://m.cafe.naver.com/ca-fe/web/cafes/25389985/articles/${postId}`
      );
    }
  };

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.title}>BEST 인기글(명예의전당) ☆</Typography>
      <Typography sx={styles.describe}>역대 최고 인기글만 모았다!</Typography>
      <DataGrid
        columns={cafeTableHeader}
        rows={rows.map((el, id) => ({ ...el, id: id + 1 }))}
        autoHeight
        hideFooter
        onCellClick={onCellClick}
        sx={{ fontSize: "12px" }}
      />
    </Box>
  );
};
